import { render, staticRenderFns } from "./PDFViewHeader.vue?vue&type=template&id=ae67da8c&scoped=true&"
import script from "./PDFViewHeader.vue?vue&type=script&lang=js&"
export * from "./PDFViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae67da8c",
  null
  
)

export default component.exports